export default [
  {
    path: '/template-imagem',
    name: 'template-imagem-list',
    component: () => import('@/views/cadastros/template-imagem/list/Index.vue'),
    meta: {
      pageTitle: 'Configurações Imagens',
      action: 'read',
      resource: 'Imagens',
    },
  },
  {
    path: '/template-imagem/novo',
    name: 'template-imagem-novo',
    component: () => import('@/views/cadastros/template-imagem/create/NewImagemHome.vue'),
    meta: {
      pageTitle: 'Nova Imagem Home',
      breadcrumb: [
        {
          text: 'Configurações Imagens',
          to: '/template-imagem',
        },
        {
          text: 'Novo',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Imagens',
    },
  },
  {
    path: '/template-imagem/edit/:cdnMarca/:familiaComercialId',
    name: 'template-imagem-edit-cdn_marca-familia_comercial_id',
    component: () => import('@/views/cadastros/template-imagem/edit/EditTemplateImagem.vue'),
    meta: {
      pageTitle: 'Nova Imagem Home',
      breadcrumb: [
        {
          text: 'Configurações Imagens',
          to: '/template-imagem',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Imagens',
    },
  },
];
